import styled from "styled-components";

export const AddFolderContainer = styled.div``;

export const ErrorMessage = styled.p`
  color:red;
  font-size: 12px;
`;